import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "./assets/styles/color.css";
import "./assets/styles/global.css";
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css'

const app = createApp(App);
app.use(router);
app.mount("#app");

const baseURL = process.env.VUE_APP_API_URL
export default baseURL;
